import { Box, styled, Typography } from '@mui/material';

import { Colors } from '../../utils/Colors';

const mdxViewerStyles = {
    color: `${Colors.white} !important`,
    fontSize: '14px',
    lineHeight: 1.6,
    fontFamily: '"Inter", sans-serif',

    '& p': {
        margin: '0 0 8px',
        minHeight: '1.6em'
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        color: Colors.white,
        margin: '12px 0 8px',
        fontWeight: 600
    },
    '& h1': { fontSize: '20px' },
    '& h2': { fontSize: '18px' },
    '& h3': { fontSize: '16px' },
    '& h4, & h5, & h6': { fontSize: '14px' },

    '& ul, & ol': {
        margin: '0 0 8px',
        paddingLeft: '20px'
    },
    '& li': {
        marginBottom: '4px'
    },

    '& a': {
        color: Colors.lightningYellow,
        textDecoration: 'none',
        '&:hover': { textDecoration: 'underline' }
    },

    '& blockquote': {
        margin: '8px 0',
        padding: '6px 12px',
        borderLeft: `3px solid ${Colors.lightningYellow}`,
        backgroundColor: 'rgba(250, 187, 24, 0.05)',
        color: Colors.white90
    },

    '& code': {
        backgroundColor: '#1a1c25',
        color: '#e2e8f0',
        fontFamily: '"Fira Code", "Fira Mono", "Roboto Mono", monospace',
        fontSize: '13px',
        borderRadius: '4px',
        padding: '2px 5px',
        border: '1px solid #26262B'
    },

    '& pre': {
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: 0,
        padding: 0,
        overflowX: 'auto',
        margin: 0
    },
    '& pre code': {
        backgroundColor: 'transparent',
        border: 'none',
        padding: 0
    },

    '& table': {
        borderCollapse: 'collapse',
        margin: '8px 0',
        width: '100%'
    },
    '& th, & td': {
        border: `1px solid ${Colors.lightShadeOfGray}`,
        padding: '6px 10px',
        textAlign: 'left'
    },
    '& th': {
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        fontWeight: 600
    },

    '& hr': {
        border: 'none',
        borderTop: `1px solid ${Colors.lightShadeOfGray}`,
        margin: '12px 0'
    }
} as const;

export const MDXViewerWrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'inline'
})<{ inline?: boolean }>(({ inline }) => ({
    ...mdxViewerStyles,
    display: inline ? 'inline' : 'block',
    backgroundColor: 'transparent'
}));

export const CodeBlockWrapper = styled(Box)({
    backgroundColor: '#1a1c25',
    border: '1px solid #26262B',
    borderRadius: '6px',
    overflowX: 'auto',
    margin: '8px 0',
    '& pre': {
        border: 'none',
        borderRadius: 0,
        margin: 0
    },
    '& code': {
        border: 'none',
        borderRadius: 0,
        padding: 0,
        backgroundColor: 'transparent'
    }
});

export const CodeBlockLanguageTag = styled(Typography)({
    display: 'block',
    fontSize: '11px',
    color: '#6b7280',
    padding: '8px 16px 0',
    fontFamily: 'Inter, sans-serif'
});
